import React from 'react';
import { Outlet } from 'react-router-dom';
import BlogPostCard from './BlogPostCard';
import { blogPosts } from '../data/blogPostMeta';

import FounderMessage from './FounderMessage';
import CompanyNews from './CompanyNews';
import Header from './Header';
import './BlogPage.css';
import './BlogPostCard.css';

function BlogPage() {
  return (
    <div className="blog-page">
      <Header className="fixed w-full bg-black z-10" />
      <Outlet />

      <section className="hero-blog-section">
        <div className="hero-content">
          <h1 className="hero-title">Explore the Haute-u AR Blog</h1>
          <p className="hero-subtitle">Insights, stories, and innovations shaping the future of fashion technology</p>
        </div>
      </section>

      <section className="blog-content-section">
        <h2 className="section-heading">Latest Blog Posts</h2>
        <div className="blog-grid fade-in">
          {blogPosts.map((post) => (
  <BlogPostCard
    key={post.slug} // ✅ Use slug instead of missing id
    title={post.title}
    excerpt={post.excerpt}
    image={post.image}
    author={post.author}
    date={post.date}
    link={`/blog/${post.slug}`}
  />
))}

        </div>

        <h2 className="section-heading">Company News & Partnerships</h2>
        <CompanyNews />

        <h2 className="section-heading">Message from the Founder</h2>
        <FounderMessage />
      </section>
    </div>
  );
  
}

export default BlogPage;
